import { CDN_URL } from '@utils/constants/url.constants';
import React from 'react';

const EmptyNotification = ({ isJC }: { isJC?: boolean | null }) => {
  console.log(`isjc on empty noti: `, isJC);
  return (
    <div
      className={`${
        isJC === false
          ? 'max-md:absolute max-md:top-1/2 max-md:left-1/2 max-md:-translate-x-1/2 max-md:-translate-y-1/2'
          : ''
      } w-full max-md:p-6`}
    >
      {isJC === false && (
        <img
          src={`${CDN_URL}assets/images/empty-notification.svg`}
          alt={''}
          className={'mx-auto block w-[187px] mb-6'}
        />
      )}
      <p
        className={
          'text-primary-navyblue text-lg leading-5 mb-2 text-center font-black'
        }
      >
        No notifications yet
      </p>
      <p className={'text-center text-md leading-5 text-neutral-pencil'}>
        Don't worry if it's empty now. This space is ready and waiting to drop
        you reminders to help with your learning.
      </p>
    </div>
  );
};

export default EmptyNotification;
